import { ShaderCue } from './shader';
import { AudioCue } from './audio';

export type ContentArchetype =
  | 'narrative'
  | 'log'
  | 'ledger'
  | 'technical'
  | 'clinical'
  | 'codex';

export type ArtworkStyle =
  // I. Cosmic & Void Phenomena
  | 'cosmic_flare'
  | 'event_horizon'
  | 'stellar_nursery'
  | 'unrendered_void'
  | 'vast_spaces'
  | 'cosmic_void'
  // II. Atmospheric Outposts & Megastructures
  | 'cloud_station'
  | 'orbital_gantry'
  | 'perseus_terminal'
  | 'deep_quarantine'
  | 'busy_stations'
  // III. Ships, Fleets & Industrial Keels
  | 'solar_armada'
  | 'solitary_hauler'
  | 'derelict_graveyard'
  | 'corporate_cutter'
  | 'lonely_ships'
  | 'cryogenic_hull'
  // IV. Claustrophobic Interiors & Wells
  | 'phosphor_spine'
  | 'cryostat_choke'
  | 'stasis_vaults'
  | 'cargo_void'
  | 'quantum_schematic'
  // V. Architecture, Transit & Tribunals
  | 'transit_corridor'
  | 'corporate_tribunal'
  | 'chrono_psych_ward'
  // VI. Existential Horror & Cosmic Ledger
  | 'synaptic_tear'
  | 'spectators_margin'
  | 'cosmic_ledger'
  | 'recrystallization_shear'
  | 'mental_tearing'
  | 'synaptic_decay'
  | 'entity_margin'
  | 'ledger_tablet';

export interface ArtworkCue {
  id: string;
  title: string;
  prompt: string;
  style: ArtworkStyle;
  caption: string;
  svgDataUri?: string;
  generatedImageUrl?: string;
}

export interface PageData {
  pageNumber: number; // 1 to 1000
  actNumber: number;  // 0 for Front Matter, 1 to 10 for Acts, 11 for Appendices
  actTitle: string;
  chapterNumber: number;
  chapterTitle: string;
  contentArchetype: ContentArchetype;
  speaker?: string;
  timestamp?: string;
  title: string;
  text: string[];
  shader: ShaderCue;
  audio: AudioCue;
  artwork?: ArtworkCue;
}

export interface ActSummary {
  actNumber: number;
  title: string;
  startPage: number;
  endPage: number;
  chapterCount: number;
  description?: string;
}

export interface ChapterSummary {
  chapterNumber: number;
  actNumber: number;
  title: string;
  startPage: number;
  endPage: number;
  pageCount: number;
  contentArchetype?: ContentArchetype;
}

export interface TomeLookup {
  getPage(pageNumber: number): PageData;
  getActs(): ActSummary[];
  getChapters(): ChapterSummary[];
  totalPages: number;
}

export const TOTAL_PAGES = 452;
export const NOVEL_AUTHOR = 'Alex Harper';
export const NOVEL_TITLE = 'The Caesura Engine';

export function isValidPageNumber(p: number): boolean {
  return Number.isInteger(p) && p >= 1 && p <= TOTAL_PAGES;
}

export function clampPageNumber(p: number): number {
  if (isNaN(p) || p < 1) return 1;
  if (p > TOTAL_PAGES) return TOTAL_PAGES;
  return Math.floor(p);
}
